<template>
  <div ref="bar" class="sec-scroll-progress" aria-hidden="true"></div>
</template>

<script setup>
// 2px reading-progress bar pinned to the top of the viewport, scrubbed by ScrollTrigger.
import { ref } from 'vue';
import { gsap } from '@/plugins/gsap';
import { useMotion } from '@/composables/security/useMotion';

const bar = ref(null);

useMotion(bar, (el) => {
  gsap.fromTo(
    el,
    { scaleX: 0 },
    {
      scaleX: 1,
      ease: 'none',
      scrollTrigger: { start: 0, end: 'max', scrub: 0.3, invalidateOnRefresh: true },
    }
  );
});
</script>

<style scoped>
.sec-scroll-progress {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: var(--sec-accent);
  transform: scaleX(0);
  transform-origin: left center;
  z-index: 1002;
  pointer-events: none;
}

@media (prefers-reduced-motion: reduce) {
  .sec-scroll-progress {
    display: none;
  }
}

@media print {
  .sec-scroll-progress {
    display: none;
  }
}
</style>
